import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import SolicitacaoDentroForaPrazoStore from "../stores/SolicitacaoDentroForaPrazoStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {Row, Col} from 'reactstrap';
import {CustomBarChart} from "../../comum/components/CustomBarChart";

const FILTROS = ['COMPETENCIA_INICIO', 'COMPETENCIA_FIM'];

@inject("store")
@DataWrapper
@observer
export class SolicitacaoDentroForaPrazo extends Component {
    constructor(props) {
        super(props);
        this.controller = new SolicitacaoDentroForaPrazoStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Solicitações dentro e fora do prazo");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS} />
                        <Row>
                            <Col xs={12} md={12} lg={10}>
                                <CustomBarChart dataKeys={["Prazo ideal", "Prazo curto"]} data={this.controller.dados}
                                        labelStraight={true} labelAxisX={"Prazo"} labelAxisY={"Quantidade"} />
                            </Col>
                        </Row>
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
